import PropTypes from 'prop-types'
import React from 'react'

import { Tooltip } from 'react-wot-bootstrap'

import { REWARD_TYPE } from '../../constants'
import { REWARD_MEDAL_TOOLTIPS } from './translations'

import styles from './RewardTooltip.scss'

export const RewardTooltip = (props) => (
        <Tooltip id={props.id}>
            <p className={styles.tooltipTitle}>{REWARD_MEDAL_TOOLTIPS[props.type].title}</p>
            <img
                className={styles.icon}
                src={require(`./images/${props.type}.png`)}
            />
            <span className={styles.tooltipDivider} />
            <p className={styles.tooltipMessage}>{REWARD_MEDAL_TOOLTIPS[props.type].message}</p>
        </Tooltip>
)

RewardTooltip.TYPES = REWARD_TYPE

RewardTooltip.propTypes = {
    type: PropTypes.oneOf(Object.values(REWARD_TYPE)).isRequired,
    id: PropTypes.string.isRequired,
}

export default RewardTooltip



// WEBPACK FOOTER //
// ./containers/WGCWXLeaderboards/components/RewardTooltip/RewardTooltip.jsx